import React, { useEffect, useState } from 'react'
import { UserInfoSectionProps } from './UserInfoSection.types'
import styles from './UserInfoSection.module.scss'
import cl from 'classnames'
import {
  Button,
  EntityInfoPropertyType,
  EntityInfoSection,
  HorizontalLine,
  ImageLabelLine,
  Input,
  LabeledLine,
  Text1
} from 'components/shared'
import { getMainImageSrcForObj, Sex, useGetIsResponsiveScreen } from 'utilities'
import { IconCalendar, IconEmail, IconGender } from 'assets'
import { Select } from 'components/shared/Select'
import { capitalize } from 'validate.js'
import moment from 'moment'
import { inject } from 'mobx-react'
import { INVITE_USER_STORE, USER_PROFILE_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { imgUrlToImage } from './UserInfoSection.utils'

const UserInfoSectionComponent = (props: UserInfoSectionProps) => {
  const {
    [USER_PROFILE_STORE]: {
      user,
      userRole,
      imageUrl,
      linkToEntityType,
      linkToEntity,
      fullName,
      onNameChange,
      onDiscardChanges,
      onSaveChanges,
      setUserProp,
      isLinkToEntityRoleSelected,
      onUserRoleSelect,
      linkToEntityOptions,
      selectedLinkToEntityId,
      onLinkToEntitySelect,
      onGoToLinkedEntityPageClick
    },
    [INVITE_USER_STORE]: {
      getUserRoles,
      userRoleOptions
    },
    editAs
  } = props

  const { isResponsive: isLargeMobile } = useGetIsResponsiveScreen('(max-width: 920px)')

  const [editMode, setEditMode] = useState(false)
  const editAsParent = editAs === 'parent'
  useEffect(() => {
    if (editAsParent) getUserRoles()
  }, [getUserRoles, editAsParent])

  if (!user) return null

  return (
    <EntityInfoSection
      // editMode
      images={user.imageUrl
        ? [imgUrlToImage(user.imageUrl)]
        : []}
      mainImage={imageUrl}
      name={fullName}
      propertyFields={[]}
      setName={onNameChange}
      textareaField={{
        label: '',
        type: EntityInfoPropertyType.TEXT,
        value: ''
      }}
      discardChanges={onDiscardChanges}
      saveChanges={onSaveChanges}
      onEditModeOn={() => setEditMode(true)}
      onEditModeOff={() => setEditMode(false)}
      sectionContainerProps={{
        extraPaddingBottom: true
      }}
      dropZoneOptions={{
        multiple: false
      }}
    >
      <div className={styles.basicInfoContainer}>
        <LabeledLine
          label='Email'
          labelIcon={IconEmail}
          className={styles.leftFieldsContainer}
          style={{ marginTop: 0 }}
        >
          <Text1 overflowEllipsis>
            {user.emailAddress}
          </Text1>
          {/* <Input
            placeholder='Email'
          /> */}
        </LabeledLine>
        <div className={styles.rightFieldsContainer}>
          <LabeledLine
            label='Gender'
            labelIcon={IconGender}
            style={{ marginTop: 0 }}
          >
            {editMode
              ? (
                <Select
                  value={user.sex || ''}
                  options={Object.values(Sex).map(s => ({
                    label: capitalize(s.toLowerCase()),
                    value: s
                  }))}
                  onChange={(sex: Sex) => setUserProp({ sex })}
                  noNoneOption
                  style={{ width: 140 }}
                />
              )
              : (
                <Text1
                  className={cl({
                    [styles.secondaryText]: !user.sex
                  })}
                >
                  {capitalize((user.sex || 'Unknown').toLowerCase())}
                </Text1>
              )}
          </LabeledLine>
          <LabeledLine
            label='Added on'
            labelIcon={IconCalendar}
            style={!isLargeMobile && { margin: '0 auto' }}
          >
            <Text1>
              {moment(user.created).format('DD.MM.YYYY')}
            </Text1>
          </LabeledLine>
        </div>
      </div>
      <HorizontalLine />
      <div className={styles.basicInfoContainer}>
        <LabeledLine
          label='Role'
          className={styles.leftFieldsContainer}
          style={{ marginTop: 0 }}
        >
          {editMode && editAsParent
            ? (
              <Select
                value={userRole.id}
                options={userRoleOptions}
                onChange={onUserRoleSelect}
              />
            )
            : (
              <Text1 overflowEllipsis>
                {userRole.label}
              </Text1>
            )}
        </LabeledLine>
        <div className={styles.rightFieldsContainer}>
          {isLinkToEntityRoleSelected && (
            <>
              <LabeledLine
                label={`Link to ${linkToEntityType}`}
                // className={styles.leftFieldsContainer}
                style={{ marginTop: 0, width: '50%' }}
              >
                {editMode && editAsParent
                  ? (
                    <Select
                      noNoneOption
                      value={selectedLinkToEntityId}
                      options={linkToEntityOptions}
                      customOptionComponent={ImageLabelLine}
                      onChange={onLinkToEntitySelect}
                    />
                  )
                  : (
                    linkToEntity && (
                      <ImageLabelLine
                        imgSrc={getMainImageSrcForObj(linkToEntity)}
                        label={linkToEntity.name}
                      />
                    )
                  )}

              </LabeledLine>
              <Button
                preset='link'
                style={{ marginLeft: 20 }}
                disabled={!linkToEntity}
                onClick={onGoToLinkedEntityPageClick}
              >
                Go to {capitalize(linkToEntityType)} page
              </Button>
            </>
          )}
        </div>
      </div>
      {editMode && !editAsParent && (
        <div className={styles.basicInfoContainer}>
          <LabeledLine
            label='Password'
            className={styles.leftFieldsContainer}
            style={{ marginTop: 0 }}
          >
            <Input
              placeholder='Password'
            />
          </LabeledLine>
          <div className={styles.rightFieldsContainer}>
            <LabeledLine
              label='Repeat password'
              // className={styles.leftFieldsContainer}
              style={{ marginTop: 0, width: '50%' }}
            >
              <Input
                placeholder='Repeat password'
              />
            </LabeledLine>
          </div>
        </div>
      )}
    </EntityInfoSection>
  )
}

const UserInfoSection = inject(
  USER_PROFILE_STORE,
  INVITE_USER_STORE
)(observer(UserInfoSectionComponent))
export { UserInfoSection }
